import PropTypes from 'prop-types';

import RcmEventsSender from 'core/components/RcmEventsSender';

import modelPropTypes, { topicAttributes } from 'core/utils/prop-types/model';


function CardWrapper(props) {
  const {
    content,
    position,
    blockId,
    contextItemId,
    className,
    card: Card,
    ...cardProps
  } = props;

  const eventsParams = { blockId, contextItemId, position, item: content.extra.rcm_item };

  return (
    <RcmEventsSender
      show={eventsParams}
      click={eventsParams}
      className={className}
    >
      <Card
        content={content}
        position={position}
        {...cardProps}
      />
    </RcmEventsSender>
  );
}

CardWrapper.propTypes = {
  card: PropTypes.func.isRequired,
  content: modelPropTypes(
    topicAttributes,
    PropTypes.shape({ rcm_item: PropTypes.object }),
  ),
  position: PropTypes.number,
  blockId: PropTypes.string.isRequired,
  contextItemId: PropTypes.string,
  className: PropTypes.string,
};

export default CardWrapper;
